import base64 from 'base-64'
import md5 from 'md5'
import utf8 from 'utf8'
import _ from 'lodash'

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const time = new Date()
  const hour = time.getHours()
  const arr = hour < 9 ? '开始新的一天新的开始' : hour <= 11 ? '新的一天' : hour <= 13 ? '休息一会儿吧' : hour < 20 ? '要不要泡壶茶休息一下' : '我猜你可能累了'
  return arr
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

// 根据权限生成菜单权限表（深度遍历）
function doGenrateMenu (menu, prefix = '*') {
  menu.forEach(item => {
    item.meta.permit = prefix.replace('*', `${item.meta.title}:*`)
    if (_.isArray(item.children)) {
      doGenrateMenu(item.children, item.meta.permit)
    }
  })
  return menu
}
export function generateMenu (menu) {
  return doGenrateMenu(menu)
}

// 根据菜单权限表过滤菜单（深度遍历）
function doFilterMenu (menu, permission) {
  menu.forEach(item => {
    if (permission.indexOf(item.path) === -1) {
      item.hidden = true
      console.log(item.path)
    }
    if (_.isArray(item.children)) {
      doFilterMenu(item.children, permission)
    }
  })
  return menu
}
export function filterMenu (menu, permission) {
  return doFilterMenu(_.cloneDeep(menu), permission)
}
function doReplaceTreeKey (tree, dict) {
  return _.map(tree, obj => {
    const res = {}
    _.mapKeys(dict, (key, value) => {
      if (_.isArray(obj[key])) {
        res[value] = replaceTreeKey(obj[key], dict)
      } else if (typeof obj[key] !== 'undefined') {
        res[value] = obj[key]
      }
    })
    return res
  })
}

export function replaceTreeKey (tree, dict) {
  return doReplaceTreeKey(_.cloneDeep(tree), dict)
}

export function doGetTreeLabel (obj, value) {
  let title = ''
  for (var i in obj) {
    if (obj[i].value === value) {
      title = obj[i].title
      break
    }
    if (obj[i].children) {
      const children = _.cloneDeep(obj[i].children)
      for (var c in children) {
        if (children[c].value === value) {
          title = children[c].title
          break
        }
      }
    }
  }
  return title
}

export function getTreeLabel (obj, value) {
  return doGetTreeLabel(_.cloneDeep(obj), value)
}

export function passwordEncryption (password = '') {
  // 转为字符串
  const pwd = `${password}`
  const pwdMD5 = md5(pwd)
  return pwdMD5
}
export function identityIdEncryption (identityId = '', timestamp = '') {
  if (typeof identityId !== 'string' || typeof timestamp !== 'string') {
    console.log('identityId、timestamp必须为字符串')
    return ''
  }

  const globalKey = 'TCG@2017#check#code'
  let returnStr = globalKey + base64.encode(utf8.encode(identityId)) + timestamp

  // 去除字母数字之外的字符集
  returnStr = returnStr.replace(/[^0-9a-zA-Z]*/g, '')
  // 倒序生成的字符
  returnStr = returnStr.split('').reverse().join('')
  // MD5加密
  returnStr = md5(returnStr)
  // 转换为小写字母
  returnStr = returnStr.toLowerCase()
  return returnStr
}
/**
 * -----------------------------------------------------------------------------
 * @description: 获取文件的URL
 * @doc: http://doc.api.czyugang.com:8099/#/  文件服务模块（内部接口）  获取图片、文件
 */
export function buildFile (id = '', w = '', h = '', watermark = 'NO') {
  const params = {
    id: id,
    w: w,
    h: h,
    watermark: watermark,
    code: md5(`${id}${w ? `w${w}` : ''}${h ? `h${h}` : ''}${watermark}`)
  }
  let result = `/api/auth/v1/file/file?`

  for (const item in params) {
    result += `${item}=${params[item]}&`
  }

  return result.slice(0, -1)
}

/**
 * -----------------------------------------------------------------------------
 * @description: 字典
 */
export function valInDict (key = '', dict = [], keyName = 'id', valueName = 'name', defaultValue = '') {
  if (key === '' || !_.isArray(dict) || dict.length === 0) {
    return key || defaultValue
  }
  for (var i = 0; i < dict.length; i++) {
    if (dict[i][keyName] === key) {
      return dict[i][valueName]
    }
  }
  return defaultValue
}

export function arrValInDict (dictKey = [], dict = [], keyName = 'id', valueName = 'name', defaultValue = []) {
  if (dictKey.length === 0 || dict.length === 0) {
    return defaultValue
  }
  const nameArr = []
  for (let i = 0; i < dictKey.length; i++) {
    for (let t = 0; t < dict.length; t++) {
      if (dictKey[i] === dict[t][keyName]) {
        nameArr.push({
          name: dict[t][valueName],
          id: dict[t][keyName]
        })
      }
    }
  }
  return nameArr
}

export function judge (value = '') {
  if (value === 'YES') return '是'
  if (value === 'NO') return '否'
}

export function convertMapDataToString (arr = []) {
  let newArray = []
  for (const a in arr) {
    newArray = newArray.concat(arr[a].join(','))
  }
  return newArray.join('|')
}

export function convertMapDataToArray (str = '') {
  const result = []
  const origin = str.split('|')
  for (const idx in origin) {
    result.push(origin[idx].split(','))
  }
  return result
}

export function judgeArray (value = []) {
  if (Array.isArray(value)) {
    if (value.length > 0) {
      return true
    } else return false
  } else return false
}

export function convertParamArray (params) {
  const res = _.cloneDeep(params)
  for (const [key, value] of Object.entries(res)) {
    if (Array.isArray(value)) {
      res[key] = value.join(',')
    }
  }
  return res
}
